import { Observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { useHistory, useLocation } from "react-router-dom";
import { ls } from "../../../common/utils/localstorage.util";
import { removeUrlParam } from '../../../common/utils/navigation.utils';
import { useAnalytics } from '../../app/data/AnalyticsProvider';
import { useStore } from '../../app/data/root.store';
import { OnBoardingHeader } from '../../layout/components/Header/OnBoardingHeader';
import { AUTH_STEPS } from "../../user/data/user.store";
import { ConciergeRightPane } from './ConciergeRightPane';
import { LoginCenterContent, LoginWrapper } from './LoginPage.styles';
import { ClientCountStep } from './steps/ClientCountStep';
import { EmailVerificationStep } from './steps/EmailVerificationStep';
import { ForgotPasswordStep } from './steps/ForgotPasswordStep';
import { InvitationStep } from './steps/InvitationStep';
import { LogInStep } from './steps/LogInStep';
import { ResetPasswordStep } from './steps/ResetPasswordStep';
import { SetPasswordStep } from './steps/SetPasswordStep';
import { SignUpStep } from './steps/SignUpStep';
import { WealthManagementTypeStep } from './steps/WealthManagementTypeStep';
import { GreetingStep } from './steps/GreetingStep';


const relevantLandingPagePlans = ['starter', 'plus', 'premium', 'familyoffice'];

function LoginPage(props) {

  const { userStore } = useStore();
  
  const history = useHistory();
  const location = useLocation();

  const { mixpanel } = useAnalytics();

  useEffect(() => {
    const distinct_id = new URLSearchParams(location.search).get('distinct_id');
    const plan = new URLSearchParams(location.search).get('plan');
    ls.set('isAfterLogin', 1);

    const alias = mixpanel.get_distinct_id()

    if (alias !== distinct_id) {
      mixpanel.alias(alias, distinct_id)
      // removeUrlParam(history, location, 'distinct_id'); 
    }
    if (plan && plan !== 'starter') {
      const score = relevantLandingPagePlans.indexOf(plan) + 1;
      ls.set('questionnaireScore', score);
      removeUrlParam(history, location, 'plan');
    }
    
    // Collect UTM parameters centrally
    const urlParams = new URLSearchParams(location.search);
    const utmParams = {
      utm_source: urlParams.get('utm_source') || mixpanel.get_property('utm_source'),
      utm_medium: urlParams.get('utm_medium') || mixpanel.get_property('utm_medium'),
      utm_campaign: urlParams.get('utm_campaign') || mixpanel.get_property('utm_campaign'),
      utm_id: urlParams.get('utm_id') || mixpanel.get_property('utm_id'),
      distinct_id: urlParams.get('distinct_id') || mixpanel.get_distinct_id(),
    };
    
    // Store the UTM parameters in userStore for all child components to access
    userStore.setAuthFields('utmParams', utmParams);
    
    return () => { }
  }, [mixpanel, history, location, userStore]);

  // Helper function to generate query string from UTM params
  const getUtmQueryString = () => {
    if (!userStore.authFields.utmParams) return '';
    
    const utmParams = userStore.authFields.utmParams;
    const queryString = Object.keys(utmParams)
      .filter(key => utmParams[key])
      .map(key => key + '=' + utmParams[key])
      .join('&');
      
    return queryString ? '?' + queryString : '';
  };

  return (<Observer>{() => (
    <div style={{ display: 'flex', height: '100%' }}>
      <LoginWrapper>
        <OnBoardingHeader isLoginLayout />

        <LoginCenterContent>
          {userStore.authStep === AUTH_STEPS.LOG_IN_STEP && <LogInStep getUtmQueryString={getUtmQueryString} />}
          {userStore.authStep === AUTH_STEPS.SIGN_UP_STEP && <SignUpStep getUtmQueryString={getUtmQueryString} />}
          {userStore.authStep === AUTH_STEPS.GREETING_STEP && <GreetingStep />}
          {userStore.authStep === AUTH_STEPS.WEALTH_MANAGEMENT_TYPE_STEP && <WealthManagementTypeStep />}
          {userStore.authStep === AUTH_STEPS.CLIENT_COUNT_STEP && <ClientCountStep />}
          {userStore.authStep === AUTH_STEPS.EMAIL_VERIFICATION_STEP && <EmailVerificationStep />}
          {userStore.authStep === AUTH_STEPS.SET_PASSWORD_STEP && <SetPasswordStep getUtmQueryString={getUtmQueryString} />}
          {userStore.authStep === AUTH_STEPS.RESET_PASSWORD_STEP && <ResetPasswordStep />}
          {userStore.authStep === AUTH_STEPS.FORGOT_PASSWORD_STEP && <ForgotPasswordStep />}
          {userStore.authStep === AUTH_STEPS.INVITATION && <InvitationStep getUtmQueryString={getUtmQueryString} />}
        </LoginCenterContent>
      </LoginWrapper>
      <ConciergeRightPane />
    </div>
  )}</Observer>)
}


export { LoginPage };
